import { WrapperProps } from '@utils/types';
import { FC, ReactElement } from 'react';

const CustomCard: FC<WrapperProps> = ({
  children,
  containerClass,
}): ReactElement => {
  return (
    <div
      className={`${containerClass ? containerClass : 'mt-4 w-full max-w-md rounded-lg bg-white lg:max-w-2xl lg:rounded-2xl'}`}
    >
      {children}
    </div>
  );
};

export default CustomCard;
